export const RESTAURANT_NAME = process.env.REACT_APP_RESTAURANT_NAME || 'QUINCE CENTRAL'
export const ONNA_CATEGORIES = process.env.REACT_APP_ONNA_CATEGORIES || 'SUSHI'